<template>
  <div>
    <div class="productBar">
      <div class="auto clearfix">
        <h2 class="fl">
          产品：大智慧财富版
          <span>非投资咨询类软件产品</span>
        </h2>
        <div class="p-nav fr">
          <span :class="{'cur' :navIndex === index}" @click="navIndex = index" v-for="(item, index) in nav" :key="index">{{ item }}</span>
        </div>
      </div>
    </div>
    <div class="gnysCon" v-show="navIndex === 0">
      <div class="wrap126">
        <div class="header">
        <router-link :to="'/order/confirm/' + id + '/12?s=official'" class="btn-buy">立即购买</router-link>
        </div>
        <div class="mod">
          <h2 class="title">观大势</h2>
          <div class="con">
            <div class="inner">
              <p>资金动向、大盘先锋</p>
              <p>大盘趋势分析模型智能分析大盘趋势</p>
              <img src="../../assets/images/product/126/img2-1.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">知热点</h2>
          <div class="con">
            <div class="inner">
              <p>热点轮动、智能复盘统计</p>
              <p>明确市场热点板块、个股的轮动方向</p>
              <img src="../../assets/images/product/126/img2-2.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">看资金</h2>
          <div class="con">
            <div class="inner">
              <p>ACE资金、主力风向标</p>
              <p>揭秘各路资金全景，与主力资金共进退</p>
              <img src="../../assets/images/product/126/img2-3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">股知道</h2>
          <div class="con">
            <div class="inner">
              <p>舆情监控、PEPB温度、ROE</p>
              <p>价值投资决策也可以如此简单</p>
              <img src="../../assets/images/product/126/img2-4.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">波段转点</h2>
          <div class="con">
            <div class="inner">
              <p>九转交易(TS时间序列-仅支持32位)、波段线、TRT</p>
              <p>识别市场趋势的潜在转折点。</p>
              <img src="../../assets/images/product/126/img2-5.jpg" alt="">
              <em>波段1- 9 -13结束之后确定结构，用于识别市场趋势的潜在转折点。</em>
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">盘中决策</h2>
          <div class="con">
            <div class="inner">
              <p>主动资金、分时DDX、双突战法</p>
              <p>实时查看买卖双方主力资金的博弈过程，把握盘中机会。</p>
              <img src="../../assets/images/product/126/img2-6.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod">
          <h2 class="title">机构热股</h2>
          <div class="con">
            <div class="inner">
              <p>机构热股、研报中心、机构去哪儿</p>
              <p>大数据跟踪明星调研机构、研究员优选的热股</p>
              <img src="../../assets/images/product/126/img2-7.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="mod mod2">
          <h2 class="title">10分钟知晓重要新闻</h2>
          <div class="con">
            <div class="inner">
              <div class="dl-box">
                <dl>
                  <dt>股票新闻:</dt>
                  <dd>去芜存菁，助您挖掘更有价值的财经资讯。</dd>
                </dl>
                <dl>
                  <dt>大报新闻：</dt>
                  <dd>利空？利好！早知道，早布局。</dd>
                </dl>
                <dl>
                  <dt>券商晨会：</dt>
                  <dd>券商观点早揭秘</dd>
                </dl>
              </div>
              <img src="../../assets/images/product/126/img2-8.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xxgnCon" v-show="navIndex === 1">
      <product-detail126 />
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>

<script>
import ProductDetail126 from "@/components/product/ProductDetail126.vue";
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      nav: ["功能演示", "详细功能"],
      navIndex: 0
    };
  },
  created () {
    document.title = "大智慧财富版";
  },
  components: {
    ProductDetail126,
    FloatBar
  }
};
</script>

<style lang="scss" scoped>
.gnysCon {
  background: #310e6c;
  letter-spacing: 1px;
  .auto1230 {
    width: 1230px;
    margin: 0 auto;
  }
  img {
    display: block;
    margin: 0 auto;
  }
  .title {
    @include line-height(80px);
    background: #f97651;
    padding: 0 25px;
    strong {
      @include fc(40px, #fff);
    }
    span {
      @include fc(30px, #fff);
      float: right;
    }
  }
  .two-minute {
    background: url(~@/assets/images/product/126/img_g02.jpg) left top no-repeat;
    height: 800px;
    & > div {
      margin-top: 64px;
      float: right;
      border: 15px solid #e3dfcd;
      border-radius: 25px;
      padding: 45px 28px 25px;
      width: 672px;
      box-sizing: border-box;
      background: #fcedd6;
      dl {
        dt {
          @include fc(40px, #ff5a2d);
          margin-bottom: 30px;
        }
        dd {
          @include fc(36px, #000);
          line-height: 48px;
          margin-bottom: 22px;
          position: relative;
          padding-left: 36px;
          &:before {
            content: "";
            display: inline-block;
            @include wh(10px, 10px);
            background: #ff5a2d;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 18px;
          }
        }
      }
    }
  }
  .three-minute {
    background: url(~@/assets/images/product/126/img_g03.jpg) left top no-repeat;
    height: 798px;
    ul {
      margin-top: 76px;
      li {
        @include fc(40px, #000);
        position: relative;
        margin-bottom: 30px;
        padding-left: 55px;
        &:before {
          content: "";
          display: inline-block;
          @include wh(25px, 25px);
          background: #ff5a2d;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 16px;
        }
      }
    }
  }
  .five-minute {
    background: #fff;
    padding: 15px 0;
    img {
      width: 1000px;
    }
  }
  .ten-minute {
    background: #fff;
    padding: 25px 0 55px;
    position: relative;
    dl {
      &:first-child {
        position: absolute;
        left: 60px;
        top: 95px;
        width: 270px;
      }
      &:nth-child(2) {
        text-align: center;
      }
      &:nth-child(3) {
        position: absolute;
        right: 60px;
        top: 95px;
        width: 270px;
      }
      dt {
        text-align: center;
        @include fc(35px, #ff5a2d);
        margin-bottom: 20px;
      }
      dd {
        @include fc(26px, #000);
        line-height: 38px;
      }
    }
    img {
      margin-top: 110px;
    }
  }
}
.wrap126{
  background: url(../../assets/images/product/126/bg.jpg) no-repeat center top;
  .header{
    width: 1200px;
    margin: 0 auto 180px;
    position: relative;
    height: 570px;
    .btn-buy{
      @include wh(280px, 100px);
      @include center-box-x;
      bottom: 0;
      text-indent: -9999rem;
      cursor: pointer;
    }
  }
  .mod{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 90px;
    .title{
      background: url(../../assets/images/product/126/title.png) no-repeat center top;
      @include center-text(415px, 119px);
      @include center-box-x;
      margin-top: -60px;
      @include fc(48px, #fed8b9);
      z-index: 2;
    }
    .con{
      border: 2px solid #d9a7d2;
      border-radius: 20px;
      box-shadow: 0px 0px 10px 4px #b17daf;
      padding: 15px 20px;
      background: #330e6d;
      position: relative;
      &:before{
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        box-shadow: 0px 0px 10px 4px #b17daf inset;
        border-radius: 18px;
      }
      .inner{
        border: 2px solid #68249d;
        border-radius: 10px;
        background: #130033;
        padding: 50px 65px 30px;
        p{
          @include fc(30px, #fed8b9);
          + p{
            margin-top: 10px;
          }
        }
        img{
          display: block;
          margin: 20px auto 0;
        }
      }
    }
  }
  .mod2{
    .title{
      background: url(../../assets/images/product/126/title2.png) no-repeat center top;
      width: 587px;
    }
    .con{
      .inner{
       padding: 60px 10px 30px;
      }
    }
    .dl-box{
      padding:50px 30px 0;
      overflow: hidden;
    }
    dl{
      float: left;
      width: 285px;
      &:nth-child(2){
        margin: -50px 120px 0 100px;
        width: 350px;
      }
      &:nth-child(3){
        width: 200px;
      }
      dt{
        @include fc(36px, #fed8b9);
        text-align: center;
        margin-bottom: 15px;
      }
      dd{
        @include fc(24px, #ffffff);
      }
    }
    img{
      margin-top: 30px
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product126.vue